import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BeverageV3Landing.module.css";
import { BtnUi } from "~/components";
import { sendPageViewWhenConsentReady } from "../../utils/adobeDataLayerUtils";

export const BeverageV3Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    return sendPageViewWhenConsentReady("Beverage V3 Landing Page", 'Passions-FavBevs', 'beverages3');
  }, []);

  const handleGetStarted = () => {
    navigate("/beverage3/preferences");
  };

  return (
    <div className={styles.landingContainer}>
      {/* Hero Section */}
      <div className={styles.heroSection}>
        <div className={styles.heroImageContainer}>
          <img
            src="https://cache.marriott.com/is/image/marriotts7prod/bonvoy-points-redemption--33160?wid=1440"
            alt="Poolside breakfast with beverages"
            className={styles.heroImage}
          />
        </div>
      </div>

      {/* Content Section */}
      <div className={styles.contentSection}>
        <h1 className={styles.mainHeading}>
          What’s your go-to drink? <br /> We’d love to know your favorites.
        </h1>

        <p className={styles.subheading}>
          Coffee to kickstart or a cocktail to unwind – what drink(s) would make
          your day?
        </p>

        <BtnUi
          data-testid="beverage-get-started"
          className={`${styles.getStartedButton} custom_click_track`}
          data-custom_click_track_value="Beverage Landing|Get Started|internal"
          onClick={handleGetStarted}
        >
          Get Started
        </BtnUi>

        <p className={styles.consentNotice}>
          Your preferences will be saved to your Marriott Bonvoy profile and
          used by Marriott Group to deliver personalized experiences.
        </p>
      </div>
    </div>
  );
};
